import Grid from "@mui/material/Grid";
import Fields from "./Fields";
import Typography from "@mui/material/Typography";

export default function FormPeopleDemographics() {
	const section = "people";

	return (
		<Grid container spacing={2} sx={{ width: "100%" }}>
			<Grid item xs={12}>
				<h2>{`People > Demographics`}</h2>
			</Grid>
			<Grid item xs={12}>
				<h3>Fields</h3>
				<Typography sx={{ width: "33%", flexShrink: 0 }}>
					Demographics
				</Typography>
				<Typography sx={{ color: "text.secondary" }}>
					Step: 'people.demographics'
				</Typography>
				<Fields title="" source={`${section}.demographics`} />
			</Grid>
		</Grid>
	);
}
